'use client';

import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { FC, useEffect, useRef } from 'react';

export interface LottieHandlerProps {
  playing?: boolean;
  animationData: any;
}

const LottieHandler: FC<LottieHandlerProps> = ({ playing, animationData }) => {
  const animationRef = useRef<LottieRefCurrentProps | null>(null);

  useEffect(() => {
    if (!animationRef.current) return;

    if (playing) {
      animationRef.current.play();
    } else {
      animationRef.current.pause();
    }
  }, [playing]);

  return (
    <Lottie animationData={animationData} autoplay={false} lottieRef={animationRef} />
  );
};

export default LottieHandler;
